export default "__VITE_PUBLIC_ASSET__198cdfdc__"